export default {
  sitiInfo: {},
  newsInfo: {},
  currentLanguge: '',
  msgnum: 0
}
